import { MdbRippleModule } from 'mdb-angular-ui-kit/ripple';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component , NO_ERRORS_SCHEMA } from '@angular/core';

@Component({
  standalone: true,
  schemas: [NO_ERRORS_SCHEMA],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MdbRippleModule],
  selector: 'app-faq-claims',
  templateUrl: './faq-claims.component.html',
  styleUrls: ['./faq-claims.component.scss'],
})
export class FaqClaimsComponent {
  accordianWithMDB: any = {};

  constructor() {
    this.accordianWithMDB = {
      one: false,
      two: false,
      three: false,
      four: false,
      five: false,
      six: false,
      seven: false,
      eight: false,
      nine: false,
    };
  }

  closeNonActiveCollapse(name): void {
    const acc = this.accordianWithMDB;
    for (const element in acc) {
      if (element != name) {
        acc[element] = false;
      }
    }
    acc[name] = !acc[name];
  }

}
